export default "__VITE_ASSET__RA09d9gg__"